import { Div, Span, CollectionView, Snack, ModalWindow, Line } from "@tblabs/truffle";
import { Order } from "../../../../../../Models/Order";
import { OrdersManager } from "../../../../../../Services/Storage/OrdersManager";
import { Router } from "../../../../../../Services/Router";
import { TimeUtils } from "../../../../../../Utils/TimeUtils";
import { ContextMenu } from "../../../../../../Components/Utils/Menu";
import { Box } from "../../../../../../Components/Utils/Box";


export class OrderHeader extends Div
{
    constructor(_router: Router, _manager: OrdersManager, orders: CollectionView<Order>, order: Order)
    {
        super();
        this.DisplayInlineBlock().Margin(8).MinWidth(180).PositionRelative();

        this.Append(
            new ContextMenu({
                "👁️ Zobacz": () => _router.GoToOrderView(order.Id),
                "📝 Edytuj": () => _router.GoToOrderEdit(order.Id),
                "🍖 Raw": () => _router.GoToOrderRawEdit(order.Id),
                "👀 Widok klienta": () => _router.GoToCustomerView(order.Id),
                "💕 Duplikuj": async () =>
                {
                    const newOrder = await _manager.Duplicate(order);
                    new Snack(`☑️ Zamówienie #${order.ShortId} zostało zduplikowane jako #${newOrder.ShortId}`, "Nowe zamówienie jest gotowe do edycji");
                    _router.GoToOrderEdit(newOrder.Id);
                },
                "🗑️ Usuń": async () =>
                {
                    if (confirm(`Czy na pewno chcesz usunąć to zamówienie ${order.ShortId}?`))
                    {
                        await _manager.Delete(order);
                        orders.Collection.Remove(order); // TODO: gdyby kolekcja siedziała w menadżerze to nie trzeba by tej linijki...
                    }
                },
                "🔄 Regeneruj": () => _router.GoToOrderCreate(order.Id),
                "📂 Archiwizuj": async () =>
                {
                    if (confirm("Czy na pewno chcesz archiwizować to zamówienie?"))
                    {
                        await _manager.Close(order);
                        new Snack(`☑️ Zamówienie #${order.ShortId} zostało zarchiwizowane`);
                        orders.Collection.Remove(order);
                    }
                },
            }).DisplayInlineBlock(),
            new Span("#" + order.ShortId).MarginLeft(8).CursorPointer()
                .Style(order.IsClosed ? "text-decoration: line-through;" : "")
                .OnClick(() => _router.GoToOrderView(order.Id)),
            new Div().Append("👉 "+order.CurrentState).FontSize(12).Color("#444"),
            new Div().Text(`🐣 Utworzone ${TimeUtils.HowLongAgo(order.Meta.CreatedAt)}\n⚡ Aktualizowane ${TimeUtils.HowLongAgo(order.Meta.UpdatedAt, "jeszcze nie aktualizowany")}`)
                .FontSize(12).Color("#666")
                .MarginTop(4).PaddingTop(4),   
            order.Notes.Private.value && new Box(new Span("PRYWATNA NOTATKA").Bold(), new Line().Margin(4), order.Notes.Private.value).Class("private-note-in-table-view")
                .OnClick(() =>
                    new ModalWindow(`Notatka prywatna do zamówienia #${order.ShortId}`, false, false, true)
                        .AddContent(order.Notes.Private.value)
                        .OpenWindow()
                ),
            order.Notes.Public.value && new Box(new Span("NOTATKA PUBLICZNA").Bold(), new Line().Margin(4), order.Notes.Public.value).Class("public-note-in-table-view")
                .OnClick(() =>
                    new ModalWindow(`Notatka publiczna do zamówienia #${order.ShortId}`, false, false, true)
                        .AddContent(order.Notes.Public.value)
                        .OpenWindow()
                ),
        );
    }
}
